/// <amd-module name="Build/CDPipelinesTab/Components/CDPipelinesTabView" />
import * as React from "react";
import { VssComponent,IVssComponentProperties } from "VSS/Platform/Layout";
import { CDPipelineRunDetails } from "Build/Client/Contracts/DataProvider";
import { ITableColumn, SimpleTableCell, Table, TwoLineTableCell } from "VSSUI/Table";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import * as Resources from "Build/CDPipelinesTab/Resources";
import { IStatusProps, Status, Statuses, StatusSize } from "VSSUI/Status";
import * as Utils_Date from "VSSUI/Utilities/Date";
import { Ago } from "VSSUI/Ago";
import { IBuildLinkingService } from "Build/Client/Linking";
import { Card } from "VSSUI/Card";
import { onClickFPS } from "VSS/Platform/FPS";
import * as Build2_WebApi from "Build/Client/Contracts/Build";

interface ICDPipelineTabProps extends IVssComponentProperties {
    data: CDPipelineRunDetails[];
}

interface ICDPipelinesRunDetailsTableItem extends CDPipelineRunDetails {
}

interface ICDPipelineRunDetailsTableRow {
    data: CDPipelineRunDetails;
}

export class CDPipelinesTabView extends VssComponent<ICDPipelineTabProps> {
    constructor(props: ICDPipelineTabProps ) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Card
                className="flex-grow bolt-table-card"
            >
                <Table
                    className = "cd-pipelines-table-border"
                    ariaLabel = {Resources.CDPipelinesLabel}
                    columns={this._tableColumns}
                    itemProvider={this._getItemProvider(this.props.data)}
                    onActivate={this._onActivateRow}
                />
            </Card>
        )
    }

    private _onActivateRow = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, tableRowDetails: ICDPipelineRunDetailsTableRow) => {
        let linkingService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
        let runPageUrl: string = linkingService.getBuildUrl(tableRowDetails.data.buildId, "", tableRowDetails.data.projectId);
        onClickFPS(this.context.pageContext, runPageUrl, true, event);
    }  

    private _getItemProvider(runs: CDPipelineRunDetails[]): ArrayItemProvider<ICDPipelinesRunDetailsTableItem> {
        const rows: ICDPipelinesRunDetailsTableItem[] = runs.map<ICDPipelinesRunDetailsTableItem>(run => {
            return run as ICDPipelinesRunDetailsTableItem;
        });
        return new ArrayItemProvider<ICDPipelinesRunDetailsTableItem>(rows);
    }

    private _renderStartTimeCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ICDPipelinesRunDetailsTableItem>, tableItem: ICDPipelinesRunDetailsTableItem): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <span className="flex-row flex-center text-ellipsis fontWeightSemiBold">
                    { tableItem.startTime && <Ago date={tableItem.startTime} format={Utils_Date.AgoFormat.Extended} /> }  
                </span>
            </SimpleTableCell>
        );
    }

    private _renderRunCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ICDPipelinesRunDetailsTableItem>, tableItem: ICDPipelinesRunDetailsTableItem): JSX.Element => {
        let commitMessage: JSX.Element = (<span className="text-ellipsis primary-text fontWeightSemiBold">{tableItem.commitMessage}</span>);
        let BuildMessage: JSX.Element = <div className="flex-row flex-center font-size">
                                <span className="font-size text-ellipsis secondary">
                                    {"#" + tableItem.buildNumber + " " + Resources.On + " " + tableItem.definitionName} &nbsp;&nbsp;
                                </span>   
                             </div>;
        return ( 
            <TwoLineTableCell 
                ariaRowIndex={rowIndex}
                columnIndex={columnIndex}  
                tableColumn={tableColumn} 
                key={"col-" + columnIndex}
                iconProps={{ render: () => {
                    return (<Status
                    {... this._statusProps(tableItem.runStatus, tableItem.runResult)}
                    key={tableItem.runResult}
                    size={StatusSize.l}
                    className="flex-self-center margin-right-8"
                />);
                }}}
                line1={commitMessage} 
                line2={BuildMessage}/>
        );
    }

    private _tableColumns: ITableColumn<ICDPipelinesRunDetailsTableItem>[] = [
        {
            id: "run",
            width: -5,
            name: Resources.RunColumnName,
            renderCell: this._renderRunCell
        },
        {
            id: "start-time",
            width: -5,
            name: Resources.StartTimeColumnName,
            renderCell: this._renderStartTimeCell
        }
    ];

    private _statusProps = (runStatus:Build2_WebApi.BuildStatus , runResult:Build2_WebApi.BuildResult): IStatusProps => {
         switch(runStatus) {
            case Build2_WebApi.BuildStatus.NotStarted:
                return {...Statuses.Waiting};
            case Build2_WebApi.BuildStatus.InProgress:
                return {...Statuses.Running};
            case Build2_WebApi.BuildStatus.Completed: {
                switch(runResult) {
                    case Build2_WebApi.BuildResult.Succeeded:
                        return {... Statuses.Success};
                    case Build2_WebApi.BuildResult.PartiallySucceeded:
                        return {... Statuses.Warning};
                    case Build2_WebApi.BuildResult.Failed:
                        return {... Statuses.Failed};
                    case Build2_WebApi.BuildResult.Canceled:
                        return {...Statuses.Canceled}
                }
            }
            case Build2_WebApi.BuildStatus.Cancelling:
                return {...Statuses.Canceled};
            default:
                return {... Statuses.Waiting};
        }
    }
}